import { adherenceLevel } from "../../../config/constants";

export const adherenceFilter = (patients, currentFilter, setCurrentFilter, isInitialFilter, setIsInitialFilter, setFilteredPatients) => {
  const sortPatients = (patients, condition) => {
    return [...patients]
      .sort((a, b) => {
        if (condition(a, b)) return -1;
        if (condition(b, a)) return 1;
        return 0;
      })
      .sort((a, b) => {
        if (condition(a, b)) {
          if (condition(b, a) && a.PATIENT_USER.toLowerCase() < b.PATIENT_USER.toLowerCase()) return -1;
          return 0;
        } else {
          return 1;
        }
      });
  };

  const sortByAdherence = (patients, min, max) => {
    return sortPatients(
      patients,
      (a) => a.isThereSomePrescription && a.isTherePrescriptionsAfter7Days && a.ADHERENCE >= min && a.ADHERENCE <= max
    );
  };

  const sortPatientsByAdherence = () => {
    let patientsToSort = [...patients];

    patientsToSort = sortPatients(patientsToSort, (a) => !a.isThereSomePrescription);
    patientsToSort = sortPatients(patientsToSort, (a) => a.isThereSomePrescription && !a.isTherePrescriptionsAfter7Days);
    patientsToSort = sortPatients(
      patientsToSort,
      (a) => a.isThereSomePrescription && a.isTherePrescriptionsAfter7Days && a.ADHERENCE >= adherenceLevel.mediumToHigh + 1
    );
    patientsToSort = sortByAdherence(patientsToSort, adherenceLevel.lowToMedium, adherenceLevel.mediumToHigh);
    patientsToSort = sortByAdherence(patientsToSort, 0, adherenceLevel.lowToMedium - 1);

    setFilteredPatients(patientsToSort);
  };

  const sortPatientsByReverseAdherence = () => {
    let patientsToSort = [...patients];

    patientsToSort = sortByAdherence(patientsToSort, 0, adherenceLevel.lowToMedium - 1);
    patientsToSort = sortByAdherence(patientsToSort, adherenceLevel.lowToMedium, adherenceLevel.mediumToHigh);
    patientsToSort = sortPatients(
      patientsToSort,
      (a) => a.isThereSomePrescription && a.isTherePrescriptionsAfter7Days && a.ADHERENCE >= adherenceLevel.mediumToHigh + 1
    );
    patientsToSort = sortPatients(patientsToSort, (a) => a.isThereSomePrescription && !a.isTherePrescriptionsAfter7Days);
    patientsToSort = sortPatients(patientsToSort, (a) => !a.isThereSomePrescription);

    setFilteredPatients(patientsToSort);
  };

  if (currentFilter === "ADHERENCE") {
    if (isInitialFilter) {
      sortPatientsByReverseAdherence();
    } else {
      sortPatientsByAdherence();
    }
    setIsInitialFilter(!isInitialFilter);
  } else {
    setCurrentFilter("ADHERENCE");
    setIsInitialFilter(true);

    sortPatientsByAdherence();
  }
};

export const userFilter = (patients, currentFilter, setCurrentFilter, isInitialFilter, setIsInitialFilter, setFilteredPatients) => {
  if (currentFilter === "ALPHABET") {
    setFilteredPatients([...patients].reverse());
    setIsInitialFilter(!isInitialFilter);
  } else {
    setCurrentFilter("ALPHABET");
    setIsInitialFilter(true);

    setFilteredPatients(
      [...patients].sort((a, b) => {
        if (a.PATIENT_USER.toLowerCase() < b.PATIENT_USER.toLowerCase()) return -1;
        return 1;
      })
    );
  }
};

export const applicationFilter = (
  patients,
  currentFilter,
  setCurrentFilter,
  hospitalApplications,
  filteredSoftwareId,
  setFilteredSoftwareId,
  setFilteredPatients
) => {
  const getSoftwareId = () => {
    const hospitalApplicationsIds = hospitalApplications.map((application) => application.SOFTWARE_ID);
    const indexSoftwareId = hospitalApplicationsIds.indexOf(filteredSoftwareId);
    const lastSoftwareId = hospitalApplicationsIds.at(-1);

    if (currentFilter !== "APPLICATIONS" || hospitalApplicationsIds[indexSoftwareId] === lastSoftwareId) {
      return hospitalApplications[0].SOFTWARE_ID;
    }

    return hospitalApplications[indexSoftwareId + 1].SOFTWARE_ID;
  };
  const softwareId = getSoftwareId();

  setCurrentFilter("APPLICATIONS");
  setFilteredSoftwareId(softwareId);

  setFilteredPatients(
    [...patients]
      .sort((a) => {
        if (a.SOFTWARE_ID.includes(softwareId)) return -1;
        return 1;
      })
      .sort((a, b) => {
        if (a.SOFTWARE_ID.includes(softwareId)) {
          if (a.PATIENT_USER.toLowerCase() < b.PATIENT_USER.toLowerCase()) return -1;
          return 0;
        } else {
          return 1;
        }
      })
  );
};
